import React from 'react'
import { renderRoutes } from 'react-router-config'

class Simulador extends React.Component {
  componentDidMount() {
    const script = document.createElement('script')

    script.innerHTML = 'var hc_hotsite = "https://www.meuvivaz.com.br/simulador"'
    script.type = 'text/javascript'
    document.head.appendChild(script)

  }

  render() {

    return (
      <React.Fragment>

        {renderRoutes(this.props.route.routes)}

      </React.Fragment>
    )
  }
}

export default Simulador



// WEBPACK FOOTER //
// ./src/components/containers/Simulador/Simulador.js